import ListingLabels from './ListingLabels';

export default ListingLabels;
